module.exports = __webpack_public_path__ + "img/team-list4.fcb7bfcd.png";